import { i18n } from '@shared/i18n';

import IdField from '@shared/fields/id-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import IntegerField from '@shared/fields/integer-field';
import EnumeratorField from '@shared/fields/enumerator-field';
// import DateModelField from '@shared/fields/date-model-field';
import BooleanField from '@shared/fields/boolean-field';
import { PropertyField } from '@modules/property/property-field';
import { SubpropertyField } from '@modules/subproperty/subproperty-field';
import { StripeConnectedAccountField } from '@modules/stripe/stripe-connected-account/stripe-connected-account-field';
import JsonField from '@shared/fields/json-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';

function label(name) {
  return i18n(`entities.stripePayout.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  created: new DateTimeField('created',label('created')),
  property: PropertyField.relationToOne('property', label('property'), {}),
  stripePayoutId: new StringField('stripePayoutId', label('stripePayoutId'), {}),
  connectedAccount: StripeConnectedAccountField.relationToOne('connectedAccount', label('connectedAccount'), {}),
  // Falta el modulo externalAccount
  externalAccount: new JsonField('externalAccount', label('externalAccount')),
  amount: new IntegerField('amount', label('amount'), {}),
  arrivalDate: new DateTimeField('arrivalDate',label('arrivalDate')),
  automatic: new BooleanField('automatic',label('automatic')),
  subproperty: SubpropertyField.relationToOne('subproperty', label('subproperty'), {}),
  currency: new EnumeratorField('currency', label('currency'), getSharedEnumeratorField('currency'), {}),
  description: new StringField('description', label('description'), {}),
  method: new EnumeratorField('method', label('method'), getSharedEnumeratorField('payoutMethodType'), {}),
  statementDescriptor: new StringField('statementDescriptor', label('statementDescriptor'), {}),
  status: new EnumeratorField('status', label('status'), getSharedEnumeratorField('payoutStatus'), {}),
  type: new EnumeratorField('type', label('type'), getSharedEnumeratorField('payoutObjectType'), {}),
  // Falta Stripe Fee -> relationToOne
  // stripeFee
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
};



export class StripePayoutModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
